/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Intro_P2Inputs */

const es_privacy_policy_intro_p2 = /** @type {(inputs: Privacy_Policy_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta Politica de Privacidad describe como recopilamos, usamos, compartimos y protegemos su informacion personal cuando utiliza nuestros servicios, incluyendo nuestra aplicacion web, API y cualquier otro medio mediante el cual interactue con nosotros.`)
};

const en_privacy_policy_intro_p2 = /** @type {(inputs: Privacy_Policy_Intro_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Privacy Policy describes how we collect, use, share, and protect your personal information when you use our services, including our web application, API, and any other means by which you interact with us.`)
};

/**
* | output |
* | --- |
* | "This Privacy Policy describes how we collect, use, share, and protect your personal information when you use our services, including our web application, API..." |
*
* @param {Privacy_Policy_Intro_P2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_intro_p2 = /** @type {((inputs?: Privacy_Policy_Intro_P2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Intro_P2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_intro_p2(inputs)
	return en_privacy_policy_intro_p2(inputs)
});
export { privacy_policy_intro_p2 as "privacy_policy.intro.p2" }